import CustomerHeader from "@components/BasicComponents/ContentAsset/CustomerHeader/CustomerHeader"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data: AdvancedSideAssetMainContent
}

const CustomerHeaderSection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<CustomerHeader data={props.data} />
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default CustomerHeaderSection
